import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import Home from "@/pages/Home";
import DatabasePage from "@/pages/Database";
import MaterialDetail from "@/pages/MaterialDetail";
import Compare from "@/pages/Compare";
import Saved from "@/pages/Saved";
import SavedComparisons from "@/pages/SavedComparisons";
import Usage from "@/pages/Usage";
import Admin from "@/pages/Admin";
import AdminAccess from "@/pages/AdminAccess";
import Login from "@/pages/Login";
import LicenseGate from "@/pages/LicenseGate";
import AuthCallback from "@/pages/AuthCallback";
import { Navigate } from "react-router-dom";

function FullScreenLoader() {
  return (
    <div className="grain min-h-screen flex items-center justify-center bg-background">
      <div className="font-mono text-sm text-muted-foreground">
        <span className="text-primary">$</span> loading<span className="cursor-blink">_</span>
      </div>
    </div>
  );
}

function AppRouter() {
  const location = useLocation();
  const { user, loading } = useAuth();

  // Process OAuth callback synchronously during render (prevents race conditions)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  if (loading) return <FullScreenLoader />;
  if (!user) return <Login />;
  if (!user.is_admin && !user.license_activated) return <LicenseGate />;

  const canDb = user.is_admin || user.database_access;

  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/compare" element={<Compare />} />
        <Route path="/database" element={canDb ? <DatabasePage /> : <Navigate to="/" replace />} />
        <Route path="/material/:id" element={canDb ? <MaterialDetail /> : <Navigate to="/" replace />} />
        <Route path="/saved" element={<Saved />} />
        <Route path="/comparisons" element={<SavedComparisons />} />
        <Route path="/usage" element={<Usage />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin/access" element={<AdminAccess />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="bottom-right" theme="dark" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
